import script from "./AppList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppList.vue?vue&type=script&setup=true&lang=js"

import "./AppList.vue?vue&type=style&index=0&id=6ae1a69e&lang=scss"

const __exports__ = script;

export default __exports__